// components/AtmosphereWash.tsx — redesign spec §3.7 "Atmosphere".
//
// P9 (redesign rebuild). Two soft radial gradient washes — violet top-right,
// magenta bottom-left — low opacity, blurred. NOT glow-blobs; this is where the
// premium "energy" lives (founder: V4 "atmospheric depth where the energy is").
// Both modes. The washes are STATIC (no animation) so they are inherently
// reduced-motion safe.
//
// Renders absolutely positioned, pointer-events: none, behind content. The host
// must be position: relative + overflow: hidden (Screen.tsx provides this). The
// exact opacities/blur/sizes are lifted verbatim from the V4 mockup.

import type { JSX } from 'react';
import { useTokens } from '../state/theme';

const WASH = {
  light: {
    tr: 'radial-gradient(circle, #a78bff33, transparent 60%)',
    bl: 'radial-gradient(circle, #e547c422, transparent 60%)',
    trBlur: 30,
    blBlur: 34,
  },
  dark: {
    tr: 'radial-gradient(circle, #7c5aff55, transparent 60%)',
    bl: 'radial-gradient(circle, #e547c433, transparent 60%)',
    trBlur: 28,
    blBlur: 32,
  },
} as const;

export function AtmosphereWash(): JSX.Element {
  const tokens = useTokens();
  const w = WASH[tokens.mode];
  return (
    <div
      aria-hidden="true"
      data-testid="atmosphere-wash"
      style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}
    >
      <div style={{ position: 'absolute', top: -120, right: -120, width: 420, height: 420, borderRadius: '50%', background: w.tr, filter: `blur(${w.trBlur}px)` }}/>
      <div style={{ position: 'absolute', bottom: -100, left: -80, width: 340, height: 340, borderRadius: '50%', background: w.bl, filter: `blur(${w.blBlur}px)` }}/>
    </div>
  );
}
